import { useOffice } from "../office/use-office.js";
import { useInactivityDetection } from "./use-inactivity-detection.js";
import { useMyPresence } from "./use-my-presence.js";
import { usePresencePing } from "./use-presence-ping.js";

export const InactivityDetector = () => {
  const { availability } = useMyPresence();
  const { team } = useOffice();

  // Ping user presence every 5 minutes to track activity
  usePresencePing({
    availability,
    msTeamId: team.msTeamId ?? null,
  });

  // Detect when user is kicked for inactivity
  useInactivityDetection({
    enabled: true,
    presenceReady: availability !== null,
  });

  return null;
};
